<div class="back-button pointer" (click)="goBack()">
  <div inlineSVG="img/icon-arrow-left.svg"></div>
  {{ text | translate }}
</div>
